import * as v from 'valibot';
import { t } from 'i18next';

export const CustomFieldEntitySchema = v.picklist([ 'store.productType', 'campaign.type' ]);

export const CustomFieldValueTypeSchema = v.picklist([ 'text', 'number', 'email', 'phone', 'date', 'checkbox', 'list', 'multiChoice' ]);

export const CustomFieldListItemRequestSchema = v.object({
	name: v.pipe(v.string(), v.nonEmpty()),
});

export const CustomFieldRequestSchema = v.object({
	name: v.pipe(v.string(), v.nonEmpty(t('Prosím nenechávejte toto pole prázdné.'))),
	required: v.boolean(),
	entity: CustomFieldEntitySchema,
	valueType: CustomFieldValueTypeSchema,
	customFieldListItems: v.array(CustomFieldListItemRequestSchema),
});

export const SettingsCustomFieldFormSchema = v.pipe(
	v.omit(CustomFieldRequestSchema, [ 'entity' ]),
	v.forward(
		v.partialCheck(
			[ [ 'valueType' ], [ 'customFieldListItems' ] ],
			(input) => {
				if (input.valueType === 'list' && input.customFieldListItems.length === 0) {
					return false;
				}

				if (input.valueType === 'multiChoice' && input.customFieldListItems.length === 0) {
					return false;
				}

				return true;
			},
			t('Výběr musí obsahovat alespoň jednu položku.'),
		),
		[ 'customFieldListItems' ],
	),
);

